import { render, staticRenderFns } from "./TabDescription.vue?vue&type=template&id=2517f51c&"
import script from "./TabDescription.vue?vue&type=script&lang=js&"
export * from "./TabDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports